var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 91,
    viewBox: "0 0 78 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9448 61.5165L4.94477 28.5165L18.4448 36.5165C21.4448 52.5165 23.9448 60.0165 25.9448 61.5165H11.9448Z",
    fill: "#2F3338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9448 50.0165H26.9448C27.7448 60.0165 34.6114 61.8499 37.9448 61.5165H56.4448C58.1114 66.0165 62.2448 77.2165 65.4448 86.0165C67.9902 93.0165 79.9448 90.0165 76.4448 81.5165C74.6114 76.1832 69.4448 63.0165 67.4448 57.5165C65.4448 52.0165 61.9448 50.0165 57.9448 50.0165Z",
    fill: "#2F3338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9448 72.0165V66.5165H12.9448V88.0165C12.9448 90.5165 17.9448 90.5165 17.9448 88.0165V72.0165H30.9448V88.0165C30.9448 90.5165 35.9448 90.5165 35.9448 88.0165V72.0165H39.9448Z",
    fill: "#2F3338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9448 84.5165V66.5165H52.9448L56.4448 76.5165V84.5165C56.4448 92.0165 44.9448 92.0165 44.9448 84.5165Z",
    fill: "#2F3338"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44477 9.51654L17.9448 7.51654C17.4448 15.5166 16.4448 17.0165 21.9448 23.0165C27.4448 29.0165 39.4448 29.0165 44.9448 20.0165C49.3448 12.8165 46.1115 5.68319 43.9448 3.01652C45.2782 2.68319 49.0448 1.81656 53.4448 1.01654C61.4448 -0.438038 63.4448 8.51636 59.9448 12.5165L47.4448 28.5165L50.4448 44.5165H24.9448L22.9448 33.0165C19.9448 31.1832 12.0448 26.3165 4.44477 21.5165C-3.15523 16.7165 3.27811 11.5165 7.44477 9.51654Z",
    fill: "#2F3338"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9448 11.5164C41.9448 4.31636 35.2782 2.51636 31.9448 2.51636C28.9448 2.51636 22.8448 4.31636 22.4448 11.5164C21.9448 20.5164 29.9448 22.0164 32.4448 22.0164C34.9448 22.0164 41.9448 20.5164 41.9448 11.5164Z",
    fill: "#2F3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.22c4fec5123e0afef0f966d9af566206.svg";
export { ForwardRef as ReactComponent };